import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { ClipboardCheck } from "lucide-react";

const Domanda = ({ d, value, onChange }) => (
  <div className={d.type === "sino" ? "flex items-center justify-between gap-3 border-b border-border/50 py-2 last:border-0" : "space-y-1.5"}>
    <Label className={d.type === "sino" ? "text-sm font-normal text-forest" : ""}>{d.label}</Label>
    {d.type === "sino" ? (
      <div className="flex shrink-0 gap-1" data-testid={`quest-${d.key}`}>
        {[["si", "Sì"], ["no", "No"]].map(([v, l]) => (
          <button key={v} type="button" onClick={() => onChange(v)} data-testid={`quest-${d.key}-${v}`}
            className={`h-8 w-12 rounded-md border text-sm transition-colors ${value === v ? "border-forest bg-forest text-white" : "bg-white text-forest hover:bg-sage/50"}`}>{l}</button>
        ))}
      </div>
    ) : d.type === "select" ? (
      <select value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={`quest-${d.key}`} className="h-10 w-full rounded-md border border-input bg-white px-3 text-sm">
        {d.options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    ) : (
      <Input value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={`quest-${d.key}`} />
    )}
    {d.help && <p className="text-xs text-muted-foreground">{d.help}</p>}
  </div>
);

// Questionario tecnico assuntivo dell'ente (RC Economia Solidale facoltativo, D&O obbligatorio).
export const QuestionarioEnte = ({ domande, value, onChange, obbligatorio }) => {
  const risposte = domande.filter((d) => String(value[d.key] || "").trim()).length;
  return (
    <div className="space-y-2 rounded-xl border border-forest/15 bg-white p-4" data-testid="questionario-ente">
      <div className="flex flex-wrap items-center gap-2">
        <ClipboardCheck className="h-4 w-4 text-terracotta" />
        <span className="font-heading font-semibold text-forest">Questionario tecnico assuntivo</span>
        <span className="ml-auto text-xs text-muted-foreground" data-testid="questionario-progress">{risposte}/{domande.length} risposte</span>
      </div>
      <p className="text-xs text-muted-foreground">{obbligatorio ? "Obbligatorio per calcolare il premio." : "Compilalo per rendere definitivo il premio: senza questionario resta indicativo."}</p>
      <div className="space-y-2">{domande.map((d) => <Domanda key={d.key} d={d} value={value[d.key]} onChange={(v) => onChange({ ...value, [d.key]: v })} />)}</div>
    </div>
  );
};
